export const TextSubmissionTypes = {
    QUIZ: 1,
    DOCUMENT: 2,
}

export const getTextSubmissionTypeName = (value) => {
    switch (value) {
        case TextSubmissionTypes.QUIZ:
            return 'Quiz'
        case TextSubmissionTypes.DOCUMENT:
            return 'Document'
        default:
            return 'Unknown'
    }
}

export const getTextSubmissionTypeDescription = (value) => {
    switch (value) {
        case TextSubmissionTypes.QUIZ:
            return 'Multiple separate questions, typically added in CSV format.'
        case TextSubmissionTypes.DOCUMENT:
            return 'All answers for a submission are included in a single document, added as a ZIP file containing PDF/DOC/DOCX files.'
        default:
            return 'Unknown'
    }
}
